import * as Yup from 'yup'
//assets
import tituloLoginSII from '../../../../../assets/tituloLoginSII.png'
//components
import { Form, Formik } from 'formik'
import { FieldWithErrorMessage } from '../../../../modules/ui/FieldWithErrorMsg'
import { sileo } from 'sileo'

// utils
import { useGlobalContext } from '../../../../../context/GlobalState'
import { useMutationCreateRepresentanteLeal } from '../../../../../queries/businessQueries'
import { formatRutForBackend } from '../../../../utils/formatter'
import businessApi from '../../../../../api/business.api'
import { OrganizationAPI } from '../../../../../api/organization.api'
import { DashboardAPI } from '../../../../../api/dashboard.api'
import { useUpdateDataAdministracion } from '../../../../../pages/useAdministracion.hooks'

/**
 *
 * @returns {JSX.Element} The rendered component.
 */
export const AddRepresentanteLegal = () => {
  const createRepresentanteLeal = useMutationCreateRepresentanteLeal()
  const { currentBusiness, setCurrentBusiness } = useGlobalContext()
  const hasRepresentanteLegal = Boolean(currentBusiness?.rutRepresentante)
  const organizationAPI = new OrganizationAPI()
  const dashboardAPI = new DashboardAPI()
  const setUpdateData = useUpdateDataAdministracion(state => state.setUpdateData)

  const schemmaValidation = Yup.object().shape({
    user: Yup.string().required('Ingresa tu RUT'),
    password: Yup.string().required('Ingresa tu clave tributaria')
  })

  const getRepresentanteErrorToast = error => {
    const status = error?.response?.status
    const message = error?.response?.data?.message

    if (message?.includes('rut characters invalid')) {
      return {
        title: 'RUT inválido',
        description: 'El RUT ingresado no es válido. Revisa que tenga el formato correcto (ej: 12345678-9).'
      }
    }
    if (message === 'wrong sii credentials') {
      return {
        title: 'No se pudo conectar con el SII',
        description: 'El RUT o la clave tributaria son incorrectos. Verifica tus credenciales e inténtalo de nuevo.'
      }
    }
    if (status === 404) {
      return {
        title: 'Empresa no encontrada',
        description: 'No encontramos la empresa para agregar el representante legal.'
      }
    }
    return {
      title: 'Error al Agregar',
      description: 'No se pudo crear correctamente. Inténtalo nuevamente 🤯'
    }
  }

  const handleSubmitForm = async (values, actions) => {
    if (!currentBusiness?.id) {
      console.error('currentBusiness or its id is undefined')
      return
    }
    try {
      // const config = { headers: { Authorization: `Bearer ${token}` } }
      // createBusiness(values)
      await sileo.promise(handleCreateRepresentante(values), {
        loading: { title: 'Agregando Representante' },
        success: {
          title: 'Representante Agregado',
          description: (
            <span className='text-green-500/80 font-medium'>
              Representante agregado exitosamente 🥳
            </span>
          )
        },
        error: getRepresentanteErrorToast
      })
      await refetchCurrentBusiness()
      await triggerDashboardSync(currentBusiness.id)
      actions.resetForm()
      actions.setSubmitting(false)
    } catch (error) {
      console.error('Error al intentar insertar en la base de datos:', error)
      actions.setSubmitting(false)
    }
  }

  const refetchCurrentBusiness = async () => {
    try {
      const { data } = await businessApi.getBusinessById(currentBusiness.id)
      setCurrentBusiness({ ...currentBusiness, rutRepresentante: data?.rutRepresentante ?? null })
    } catch (error) {
      console.error('Error al refrescar la empresa tras actualizar el representante legal:', error)
    }
  }

  const triggerDashboardSync = async businessId => {
    try {
      await organizationAPI.getUpdatePreguntonSingleBusiness(businessId)
      const response = await dashboardAPI.regenerateDashboard(businessId)
      setUpdateData(true)
      window.dispatchEvent(
        new CustomEvent('dashboardRegenerated', {
          detail: { businessId, data: response.data }
        })
      )
    } catch (error) {
      console.error('Error al disparar la sincronización tras actualizar el representante legal:', error)
    }
  }

  const handleCreateRepresentante = async values => {
    if (!currentBusiness?.id) {
      console.error('currentBusiness or its id is undefined')
      return
    }
    const businessId = currentBusiness.id
    const payload = { ...values, user: formatRutForBackend(values.user).trim() }
    const response = await createRepresentanteLeal.mutateAsync({ businessId, payload })
    console.info(response)
  }

  const AddCompanyForm = () => (
    <Formik
      validationSchema={schemmaValidation}
      initialValues={{ user: '', password: '' }}
      onSubmit={handleSubmitForm}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className='shadow-md my-3 rounded-b-md'>
            <div className='mb-2  flex justify-center bg-primary h-[74px] py-3'>
              <img src={tituloLoginSII} alt='tituloLoginSII' />
            </div>

            <ul className='flex flex-col gap-3 px-6 pb-6'>
              <li>
                <FieldWithErrorMessage
                  type='text'
                  name='user'
                  label='RUT'
                  placeholder='Ej: 123456789'
                />
              </li>
              <li>
                <FieldWithErrorMessage
                  type='password'
                  name='password'
                  label='Ingresar Clave Tributaria'
                  placeholder='Ingresa tu clave tributaria'
                />
              </li>
              <li>
                <button
                  disabled={isSubmitting}
                  type='submit'
                  className='btn-primary text-sm disabled:cursor-not-allowed disabled:opacity-50'
                >
                  {isSubmitting
                    ? 'VALIDANDO CREDENCIALES...'
                    : hasRepresentanteLegal
                      ? 'ACTUALIZAR REPRESENTANTE'
                      : 'AGREGAR REPRESENTANTE'}
                </button>
              </li>
            </ul>
          </div>
        </Form>
      )}
    </Formik>
  )

  return (
    <section className='py-2 w-full flex flex-col items-center'>
      <h3 className='font-bold text-xl mb-4 text-center'>
        {hasRepresentanteLegal ? 'Actualizar Representante Legal' : 'Agregar Representante Legal'}
      </h3>

      <div className='w-full max-w-sm'>
        <AddCompanyForm />
      </div>
    </section>
  )
}
